import { takeEvery, fork, put, all, call } from "redux-saga/effects"
import toastr from "toastr";

// Login Redux States
import {
  ADD_BATCH,
  EDIT_BATCH,
  VIEW_BATCH,
  LIST_BATCH,
  LIST_TRACK_BATCH,
  DELETE_BATCH,
  ADD_PARTICIPANTS,
  EDIT_PARTICIPANTS,
  VIEW_PARTICIPANTS,
  LIST_PARTICIPANTS,
  LIST_PARTICIPANTSTATUS,
  DELETE_PARTICIPANTS,
  SEND_INVITATION_MAIL,
  LIST_PARTICIPANTS_TRACK_BATCH
} from "./actionTypes"
import { batchSuccess, batchError } from "./actions"


import {
  onAddBatch,
  onEditBatch,
  onViewBatch,
  onListBatch,
  onListBatchTrack,
  onDeleteBatch,
  onAddParticipants,
  onEditParticipants,
  onListParticipants,
  onViewParticipants,
  onDeleteParticipants,
  onSendInvitationMail,
  onListTrackParticipants
} from "helpers/backend_api_helper";

// add batch
function* addBatch({ payload: { data, history, callback } }) {
  try {
    const response = yield call(onAddBatch, data);
    yield put(batchSuccess(response));
    callback && callback(response);
  } catch (error) {
    yield put(batchError(error?.response?.data?.message || "Server Error"));
  }
}

// edit batch
function* editBatch({ payload: { data, id, callback } }) {
  try {
    const response = yield call(onEditBatch, data, id);
    yield put(batchSuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(batchError(error?.response?.data?.message || "Server Error"));
  }
}

// list batch
function* listBatch({ payload: { data, callback } }) {
  try {
    const response = yield call(onListBatch, data);
    yield put(batchSuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(batchError(error?.response?.data?.message || "Server Error"));
  }
}

// list batch track
function* listBatchTrack({ payload: { id, callback } }) {
  try {
    const response = yield call(onListBatchTrack, id);
    yield put(batchSuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(batchError(error?.response?.data?.message || "Server Error"));
  }
}

// view batch
function* viewBatch({ payload: { data, history } }) {
  try {
    const response = yield call(onViewBatch, data);
    yield put(batchSuccess(response));

  } catch (error) {
    yield put(batchError(error?.response?.data?.message || "Server Error"));
  }
}

// delete batch
function* deleteBatch({ payload: { data, callback } }) {
  try {
    const response = yield call(onDeleteBatch, data);
    yield put(batchSuccess(response));

    callback && callback(response);
  } catch (error) {
    yield put(batchError(error?.response?.data?.message || "Server Error"));
  }
}


// text
// add Batch
function* addParticipants({ payload: { data, id, callback } }) {
  try {
    const response = yield call(onAddParticipants, data, id);
    yield put(batchSuccess(response));
    callback && callback(response);
  } catch (error) {
    toastr.error(error?.response?.data?.message);
    yield put(batchError(error?.response?.data?.message || "Server Error"));
  }
}

// edit Batch
function* editParticipants({ payload: { data, id, callback } }) {
  try {
    const response = yield call(onEditParticipants, data, id);
    yield put(batchSuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(batchError(error?.response?.data?.message || "Server Error"));
  }
}

// list participant
function* listParticipants({ payload: { data, id, callback } }) {
  try {
    const response = yield call(onListParticipants, data, id);
    yield put(batchSuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(batchError(error?.response?.data?.message || "Server Error"));
  }
}


function* listParticipantStatus({ payload: { data, id, callback } }) {
  try {
    const response = yield call(onListParticipants, data, id);
    yield put(batchSuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(batchError(error?.response?.data?.message || "Server Error"));
  }
}

// list participant Track
function* listParticipantsTrack({ payload: { batchId, participantId, callback } }) {
  try {
    const response = yield call(onListTrackParticipants, batchId, participantId);
    yield put(batchSuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(batchError(error?.response?.data?.message || "Server Error"));
  }
}

// view Batch
function* viewParticipants({ payload: { data, history } }) {
  try {
    const response = yield call(onViewParticipants, data);
    yield put(batchSuccess(response));

  } catch (error) {
    yield put(batchError(error?.response?.data?.message || "Server Error"));
  }
}

// delete Batch
function* deleteParticipants({ payload: { data, callback } }) {
  try {
    const response = yield call(onDeleteParticipants, data);
    yield put(batchSuccess(response));

    callback && callback(response);
  } catch (error) {
    yield put(batchError(error?.response?.data?.message || "Server Error"));
  }
}

// Send Invitation
function* sendInvitationMail({ payload: { data, callback } }) {
  try {
    const response = yield call(onSendInvitationMail, data);
    callback && callback(response);
    yield put(batchSuccess(response));

  } catch (error) {
    yield put(batchError(error?.response?.data?.message || "Server Error"));
  }
}




function* BatchSaga() {
  yield takeEvery(ADD_BATCH, addBatch);
  yield takeEvery(EDIT_BATCH, editBatch);
  yield takeEvery(LIST_BATCH, listBatch);
  yield takeEvery(LIST_TRACK_BATCH, listBatchTrack);
  yield takeEvery(VIEW_BATCH, viewBatch);
  yield takeEvery(DELETE_BATCH, deleteBatch);

  // text
  yield takeEvery(ADD_PARTICIPANTS, addParticipants);
  yield takeEvery(EDIT_PARTICIPANTS, editParticipants);
  yield takeEvery(LIST_PARTICIPANTS, listParticipants);
  yield takeEvery(LIST_PARTICIPANTSTATUS, listParticipantStatus);
  yield takeEvery(LIST_PARTICIPANTS_TRACK_BATCH, listParticipantsTrack);
  yield takeEvery(VIEW_PARTICIPANTS, viewParticipants);
  yield takeEvery(SEND_INVITATION_MAIL, sendInvitationMail);
  yield takeEvery(DELETE_PARTICIPANTS, deleteParticipants);
}

export default BatchSaga;

